<template>
  <div class="kind">
    <CategoryItem
      :product="recommendedProduct"
      :dataList="recommendedData"
      :category="recommendedCategory"
      :colorclass="'recommended'"
      :title="'精品推荐'"
    ></CategoryItem>
    <CategoryItem
      :product="hotProduct"
      :dataList="hotData"
      :category="hotCategory"
      :colorclass="'hot-list'"
      :title="'热门榜单'"
    ></CategoryItem>
    <CategoryItem
      :product="newProduct"
      :dataList="newData"
      :category="newCategory"
      :colorclass="'new-product'"
      :title="'首发新品'"
    ></CategoryItem>
    <CategoryItem
      :product="promotionalProduct"
      :dataList="promotionalData"
      :category="promotionalCategory"
      :colorclass="'promotional-items'"
      :title="'促销单品'"
    ></CategoryItem>
  </div>
</template>

<script>
import CategoryItem from "@components/pc/activities/CategoryItem";
export default {
  name: "GoodKind",
  props: ["allInfomation"],
  components: {
    CategoryItem
  },
  data() {
    return {
      // 精品推荐属性名
      recommendedCategory: [],
      recommendedData: [],
      recommendedProduct: [],
      // 热门榜单
      hotProduct: [],
      hotData: [],
      hotCategory: [],
      // 首发新品
      newProduct: [],
      newData: [],
      newCategory: [],
      // 促销单品
      promotionalProduct: [],
      promotionalData: [],
      promotionalCategory: []
    };
  },
  watch: {
    allInfomation() {
      if (
        this.allInfomation &&
        Object.keys(this.allInfomation.info).length > 0
      ) {
        this.recommendedData = this.allInfomation.info.bastList;
        this.hotData = this.allInfomation.likeInfo;
        this.newData = this.allInfomation.info.firstList;
        this.promotionalData = this.allInfomation.benefit;

        this.recommendedCategory = this.allInfomation.info.bastList.cate_id;
        this.hotCategory = this.allInfomation.likeInfo.cate_id;
        this.newCategory = this.allInfomation.info.firstList.cate_id;
        this.promotionalCategory = this.allInfomation.benefit.cate_id;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.kind
  width 1200px
  margin 80px auto
  display flex
  justify-content space-between
</style>
